

module.exports = __webpack_require__.stylable.create(
    "WeeklyPopper62882837",
    {"classes":{"root":"WeeklyPopper62882837__root","ScrollBarStyle":"WeeklyPopper62882837__ScrollBarStyle","ScrollBarThumb":"WeeklyPopper62882837__ScrollBarThumb","CalendarPopover":"WeeklyPopper62882837__CalendarPopover","Popper":"WeeklyPopper62882837__Popper","EventWrapper":"WeeklyPopper62882837__EventWrapper","Event":"WeeklyPopper62882837__Event"},"vars":{},"stVars":{"EventTitleColor":"\"fallback(color(--eventTitleColor), color(color-5))\"","BackgroundColor":"\"fallback(color(--calendarBackgroundColor), fallback(color(--bgBoxColor), color(color-1)))\"","EventCornerRadius":"'\"unit(fallback(--eventCornerRadius, 0), px)\"'"},"keyframes":{}},
    "",
    16,
    "WeeklyPopper62882837",
    null
);
